import { darken } from 'polished'
import styled from 'styled-components/macro'

import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { SearchInput } from '../../components/SearchModal/styleds'

export const TopSection = styled(AutoColumn)`
  width: 100%;
`

export const PoolSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 32px;
  width: 100%;
  justify-self: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
  grid-template-columns: 1fr 1fr;
`};

  ${({ theme }) => theme.mediaWidth.upToSmall`
  grid-template-columns: 1fr;
`};
`

export const DataRow = styled(RowBetween)`
  ${({ theme }) => theme.mediaWidth.upToSmall`
 flex-direction: column;
`};
`

export const SortSection = styled.div`
  display: flex;
`
export const SortField = styled.div`
  margin: 0px 5px 0px 5px;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  line-height: 20px;
`

export const SortFieldContainer = styled.div`
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToSmall`
 display: none;
`};
`

export const StyledSearchInput = styled(SearchInput)`
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.bg4};
  border-radius: 0;
  transition: border 50ms;
  padding: 0 1rem;
  :hover,
  :focus {
    border: none;
    border-bottom: 1px solid ${({ theme }) => theme.bg5};
    outline: none;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 1rem;
    font-size: 14px;
  `}
`

export const StyledFiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem;

  ${({ theme }) => theme.mediaWidth.upToSmall`
  flex-direction: column;
  align-items: flex-start;
  `};
`

export const StyledToggleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 14px
  `}
  ${({ theme }) => theme.mediaWidth.upToSmall`
   margin-bottom: 1rem;
   width: 100%;
   display: flex;
   justify-content: space-between;
  `};
`

export const StyledSortContainer = styled.div`
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 14px
  `}
`

export const StyledSortOption = styled.span`
  display: inline-flex;
  flex-direction: row;
  font-size: 16px;
  font-weight: 600;
  &:hover,
  &:focus,
  &:active {
    cursor: pointer;
    color: ${({ theme }) => darken(0.1, theme.text1)};
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 14px
  `}
`

export const StyledArrowContainer = styled.span`
  min-width: 1rem;
`
